import { useMemo } from 'react'
import styled from 'styled-components'
import { qrPath } from '../logic/qr'

const Tile = styled.div`
  display: grid;
  place-items: center;
  padding: 10px;
  border-radius: 16px;
  background: #dfe9ff;
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`

/** The verification code: dark modules on a moon-coloured tile, drawn as one path from the page's own address. */
export default function QrCode({ value, size = 148, label }: { value: string; size?: number; label?: string }) {
  const { d, size: n } = useMemo(() => qrPath(value, 1, 'M'), [value])
  return (
    <Tile style={{ width: size, height: size }} data-testid="qr" role="img" aria-label={label ?? `QR code for ${value}`}>
      <svg viewBox={`0 0 ${n} ${n}`} shapeRendering="crispEdges" aria-hidden="true">
        <path d={d} fill="#050713" />
      </svg>
    </Tile>
  )
}
